import { queryOptions } from '@tanstack/react-query';
import { getDamagedUserInformationQueryFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedUserInformation/getDamagedUserInformationQueryFunction';
import convertTimestampToShamsi from '@/common/utils/convertTimestampToShamsi';

export const getDamagedUserInformationQueryOptions = (
  id: number,
  damaged_id: number,
) =>
  queryOptions({
    queryKey: ['getDamagedUserInformation', id, damaged_id],
    queryFn: () => getDamagedUserInformationQueryFunction(id, { damaged_id }),
    select: (data) => ({
      id: id,
      personal_information: {
        ...data.personal_information,
        owner_type: data.personal_information?.owner_type?.const,
        gender: data.personal_information?.gender?.const,
        birthdate:
          data?.personal_information?.birthdate &&
          convertTimestampToShamsi(+data.personal_information.birthdate),
      },
      contact_information: data.contact_information,
      mappedData: {
        personal_information:
          data.personal_information?.owner_type?.const === 'legal'
            ? [
                {
                  label: 'نوع مالکیت',
                  value: data.personal_information?.owner_type?.fa_const,
                },
                {
                  label: 'نام',
                  value: data.personal_information?.name,
                },
                {
                  label: 'شماره ثبت',
                  value: data.personal_information?.registration_number,
                },
                {
                  label: 'کد اقتصادی',
                  value: data.personal_information?.economic_code,
                },
                {
                  label: 'شناسه ملی',
                  value: data.personal_information?.national_id,
                },
              ]
            : [
                {
                  label: 'نوع مالکیت',
                  value: data.personal_information?.owner_type?.fa_const,
                },
                {
                  label: 'جنسیت مالکیت',
                  value: data.personal_information?.gender?.fa_const,
                },
                {
                  label: 'نام',
                  value: data.personal_information?.first_name,
                },
                {
                  label: 'نام خانوادگی',
                  value: data.personal_information?.last_name,
                },
                {
                  label: 'تاریخ تولد',
                  value:
                    data?.personal_information?.birthdate !== undefined
                      ? convertTimestampToShamsi(
                          Number(data.personal_information?.birthdate),
                        )
                      : undefined,
                },
                {
                  label: 'کد کلی',
                  value: data.personal_information?.national_code,
                },
                {
                  label: 'نام پدر',
                  value: data.personal_information?.father_name,
                },
                {
                  label: 'شماره شناسنامه',
                  value: data.personal_information?.identity_number,
                },
                {
                  label: 'محل صدور شناسنامه',
                  value: data.personal_information?.identity_issue_location,
                },
              ],
        contact: [
          {
            label: 'تلفن همراه',
            value: data.contact_information?.phone_number,
          },
          {
            label: 'تلفن ',
            value: data.contact_information?.phone,
          },
          {
            label: 'کد پستی',
            value: data.contact_information?.postal_code,
          },
          {
            label: 'ادرس',
            value: data.contact_information?.address,
          },
        ],
      },
    }),
  });
